import { COLUMN_ANTI_PASSBACK, COLUMN_CONTROLLER, COLUMN_DOORS_COUNT, COLUMN_NAME, COLUMN_SITE } from "../../constants/column-types";
import { FILTER_CONTROLLER, FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";
import LookupTypes from "../LookupTypes";

const ZoneColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "zoneName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Controllers",
        accessor: "controller",
        isNumeric: false,
        id: 1,
        sortByName: "controller.deviceImprox.devName",
        sortDirection: "asc",
        active: true,
        searchOnName: "controller.deviceImprox.id",
        lookupName: "controller.deviceImprox.devName",
        translationKey: "controllers",
        columnId: COLUMN_CONTROLLER,
        settingDataName: "deviceImprox",
        filterId: FILTER_CONTROLLER
    },
    {
        heading: "Anti-Passback",
        accessor: "antiPassback",
        isNumeric: false,
        id: 2,
        sortByName: "zoneApb",
        sortDirection: "asc",
        active: true,
        translationKey: "antiPassback",
        columnId: COLUMN_ANTI_PASSBACK,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 3,
        sortByName: "controller.site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: LookupTypes.zoneBySiteId,
        lookupName: "controller.deviceImprox.site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    },
    {
        heading: "Doors",
        accessor: "doors",
        isNumeric: true,
        id: 4,
        active: true,
        translationKey: "doors",
        columnId: COLUMN_DOORS_COUNT,
    },
];

export default ZoneColumns;
